<script lang="ts">
	import { EventRestart } from "./event_types";

	export let flagsLeft;
	export let currentTime, startTime;

	import { createEventDispatcher } from 'svelte';

	const fireRestart = createEventDispatcher<EventRestart>();
	const restart = (): any  => fireRestart('restart');

	let timeElapsed : string;
	$: {
		let mins = '0';
		let secs = '0';

		const seconds = Math.round((currentTime - startTime) / 1000);

		if (seconds > 0) {
			mins = Math.round(seconds / 60).toString();
			secs = (seconds % 60).toString();
		}

		if (mins < 10) mins = '0' + mins;
		if (secs < 10) secs = '0' + secs;

		timeElapsed = `${mins}:${secs}`;
	}
</script>

<header>
	<div style="width: 30%">
		<p>Flags left: <b>{flagsLeft}</b></p>
	</div>
	<div style="text-align: center; width: 30%">
		<p>[ <a href="{null}" on:click="{restart}">RESTART</a> ]</p>
	</div>
	<div style="text-align: right; width: 40%">
		<p>Time elapsed: <b>{timeElapsed}</b></p>
	</div>
</header>

<style>
	header {
		width: 602px;
		margin: auto;
		clear: both;
		display: block;
	}
	header div {
		float: left;
	}
	header div a {
		text-transform: uppercase;
		font-weight: bold;
	}
</style>
